import React, { useState, useEffect, setGlobal } from 'react';
import { Input, Form, Button, Row, Col } from 'antd';
import firebase from 'firebase/app';
import { useParams } from 'react-router-dom';
import 'firebase/firestore';
import { message } from 'antd';

const Vitals = () => {
    const [loading, setLoading] = useState(false);
    const { appointmentId } = useParams();
    const [form] = Form.useForm();
    const [editMode, setEditMode] = useState(false);
    const [recordID, setRecordID] = useState(null);

    const [bmi, setBmi] = useState(null);

    useEffect(() => {
        //for get BMI index
        const formValues = form.getFieldsValue();
        const calculatedBmi = calculateBmi(formValues.weight, formValues.height);
        setBmi(calculatedBmi);
        const fetchVitalsRecord = async () => {
            try {
                const db = firebase.firestore();
                const querySnapshot = await db
                    .collection('vitals_records')
                    .where('appointmentId', '==', appointmentId)
                    .get();

                if (!querySnapshot.empty) {
                    const record = querySnapshot.docs[0].data();
                    setRecordID(querySnapshot.docs[0].id)
                    if (record.appointmentId) {
                        setEditMode(true);
                    }
                    form.setFieldsValue({
                        weight: record.weight,
                        height: record.height,
                        bloodPressure: record.bloodPressure,
                        oxygenSaturation: record.oxygenSaturation,
                        pulse: record.pulse,
                    })
                }
            } catch (error) {
                console.error('Error fetching record:', error);
            }
        };

        fetchVitalsRecord();
    }, [appointmentId, editMode, form]);

    const handleSubmit = async (data) => {
        setLoading(true);
        try {
            const vitalsRecord = {
                weight: data.weight || null,
                height: data.height || null,
                BMI: bmi || null,
                bloodPressure: data.bloodPressure || null,
                oxygenSaturation: data.oxygenSaturation || null,
                pulse: data.pulse || null,
                appointmentId: appointmentId,
                date: new Date().toISOString(),
            };
            const db = firebase.firestore();
            if(editMode) {
                await db.collection('vitals_records').doc(recordID).update(
                    vitalsRecord
                );
            } else {
                await db.collection('vitals_records').add(vitalsRecord);
                setEditMode(true);
            }
            // setGlobal({vitals: vitalsRecord});

            // Display success message
            message.success('Record added successfully');
        } catch (error) {
            console.error('Error adding record:', error);
            // Display error message
            message.error('Error adding record', error);

            // Handle error here
        } finally {
            setLoading(false);
        }
    };


    // Function to calculate BMI
    const calculateBmi = (weight, height) => {
        if (weight && height) {
            const heightInMeters = height / 100; // Convert height to meters
            return (weight / (heightInMeters ** 2)).toFixed(2); // BMI formula
        }
        return null;
    };

    // Handle form value changes
    const onFormValuesChange = (_, allValues) => {
        const calculatedBmi = calculateBmi(allValues.weight, allValues.height);
        setBmi(calculatedBmi);
    };
    // ... rest of your existing code


    return (
        <Form onFinish={handleSubmit} form={form}  onValuesChange={onFormValuesChange}>
            <Row gutter={[16, 16]}>
                <Col span={24}>
                    <Form.Item
                        name="weight"
                        label="Weight"
                        labelCol={{ span: 4 }}
                        wrapperCol={{ span: 8 }}
                    >
                        <Input
                            placeholder="Weight"
                            addonAfter="kg"
                        />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        name="height"
                        label="Height"
                        labelCol={{ span: 4 }}
                        wrapperCol={{ span: 8 }}
                    >
                        <Input
                            placeholder="Height"
                            addonAfter="cm"
                        />    
                    </Form.Item>
                    <Form.Item
                        name="BMI"
                        label="BMI"
                        labelCol={{ span: 4 }}
                        wrapperCol={{ span: 8 }}
                    >
                        
                        {/* Display BMI */}
                        {bmi && (
                                    <div>
                                        {bmi} kg/m²
                                    </div>
                         )}
                         
                    </Form.Item>

                        
                  
                </Col>
                <Col span={24}>
                    <Form.Item
                        name="bloodPressure"
                        label="Blood Pressure"
                        labelCol={{ span: 4 }}
                        wrapperCol={{ span: 8 }}
                    >
                        <Input
                            placeholder="Blood Pressure"
                            addonAfter="mmHg" 
                        />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        name="oxygenSaturation"
                        label="Oxygen Saturation"
                        labelCol={{ span: 4 }}
                        wrapperCol={{ span: 8 }}
                    >
                        <Input
                            placeholder="Oxygen Saturation"
                            addonAfter="%"
                        />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        name="pulse"
                        label="Pulse"
                        labelCol={{ span: 4 }}
                        wrapperCol={{ span: 8 }}
                    >
                        <Input
                            placeholder="Pulse"
                            addonAfter="bpm"
                        />
                    </Form.Item>
                </Col>
            </Row>
            <Form.Item wrapperCol={{ span: 12, offset: 12 }}>
                <Button type="primary" htmlType="submit" loading={loading}>
                    {editMode ? 'Edit' : 'Submit'}
                </Button>
            </Form.Item>
        </Form>

        
    );
};

export default Vitals;
